import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-send-letter',
    templateUrl: './send-letter.component.html',
    styleUrls: ['./send-letter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SendLetterComponent implements OnInit {
  @Input() form: UntypedFormGroup;
  @Output() reload: EventEmitter<void> = new EventEmitter();

  hasEmail: boolean = false;
  isEmailValid: boolean = false;

  private _email: string;
  get email(): string {
    return this._email;
  }
  @Input() set email(value: string) {
    this._email = value;
    this.hasEmail = !!this._email;
    this.isEmailValid = this.validateEmail(this._email);
  }

  constructor() {}

  ngOnInit(): void {}

  get hasReloadSubscribers(): boolean {
    const output = this.reload as unknown as { observers?: unknown[]; observed?: boolean };
    return output.observed ?? (output.observers?.length ?? 0) > 0;
  }

  validateEmail(email: string): boolean {
    var re = /\S+@\S+\.\S+/;
    return re.test(email?.toLowerCase());
  }
}
